module.exports = __webpack_public_path__ + "img/index14.2341de2d.png";